/**
 * Shared graph builder for track nodes and learning-path entries (same parent/order semantics).
 * @param {Array<{ id: string, parent: string|null, order: number }>} items
 * @returns {Array} items with depth and childIds
 */
export function buildOrderedNodeGraph(items) {
  if (!items || items.length === 0) return [];
  const byId = new Map(items.map((n) => [n.id, { ...n, childIds: [] }]));
  byId.forEach((n) => {
    if (n.parent != null && byId.has(n.parent)) {
      byId.get(n.parent).childIds.push(n.id);
    }
  });
  byId.forEach((n) => {
    n.childIds.sort((a, b) => byId.get(a).order - byId.get(b).order);
  });
  const result = [];
  const roots = items.filter((n) => n.parent == null).sort((a, b) => a.order - b.order);
  function visit(id, depth) {
    const node = byId.get(id);
    if (!node) return;
    result.push({ ...node, depth, childIds: node.childIds || [] });
    (node.childIds || []).forEach((cid) => visit(cid, depth + 1));
  }
  roots.forEach((r) => visit(r.id, 0));
  return result;
}
